import React from 'react'
import { Popup } from 'devextreme-react/popup';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { ProgressBar } from 'devextreme-react/progress-bar';
import './index.scss';
import { useSelector } from 'react-redux';
import { SET_PROGRESS_LOAD_INDICATOR_VALUE, TOGGLE_PROGRESS_LOAD_INDICATOR } from '../../mdae-common-reducer';
export interface IMdaeLoadIndicator {
}
export const toggleProgressBarLoaderPopupVisible = (
  dispatch,
  isVisible,
  progressLoadIndicatorProgressText = "Uploading"
) => {
  dispatch({
    type: TOGGLE_PROGRESS_LOAD_INDICATOR,
    isVisible,
    progressLoadIndicatorProgressText,
  });
};
export const setProgressBarLoaderPopupValue = (
  dispatch,
  progressLoadIndicatorValue
) => {
  dispatch({
    type: SET_PROGRESS_LOAD_INDICATOR_VALUE,
    progressLoadIndicatorValue,
  });
};
const MdaeProgressLoadIndicator: React.FC<IMdaeLoadIndicator> = () => {
    const progressLoadIndicatorValue: number = useSelector(
        (state: any) => state.mdaeCommonReducer.progressLoadIndicatorValue
      );
    const progressLoadIndicatorProgressText = useSelector(
        (state: any) => state.mdaeCommonReducer.progressLoadIndicatorProgressText
      );
    const isProgressLoadIndicatorVisible = useSelector(
        (state: any) => state.mdaeCommonReducer.isProgressLoadIndicatorVisible
      );
    return (<Popup
        showTitle={false}
        width={400}
        height={100}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        deferRendering={false}
        wrapperAttr={{class: "load-indicator-popup"}}
        style={{ padding: '10px' }}
        onTitleRendered={(e) => {
            e.component.registerKeyHandler("escape", function (arg) {
                arg.stopPropagation();
            })
        }
        }
        visible={isProgressLoadIndicatorVisible}
    >
        <div className="load-indicator-popup-content">
            <LoadIndicator visible={true} style={{ alignSelf: 'center' }}></LoadIndicator>

            <ProgressBar
                min={0}
                max={100}
                width="100%"
                showStatus
                value={Math.round(progressLoadIndicatorValue)}
                statusFormat={(value) => {
                    return progressLoadIndicatorProgressText + ": " + value * 100 + "%";
                }}
            />
        </div>
    </Popup>);
}

export default MdaeProgressLoadIndicator;